/**
 * Section quizzes (delprov) should not include fill-in-blank questions.
 */
export function isFillInBlankQuestionType(questionType: unknown): boolean {
  if (questionType == null) return false;
  const normalized = String(questionType).replace(/[\s_]/g, "").toLowerCase();
  return normalized === "fillinblank";
}
